import React from "react";
import clsx from "clsx";

/**
 * Visible field error (icon + text). Tie it to the control with aria-describedby.
 * Do not use role="alert" — NVDA/JAWS would read every error on submit.
 */
export const RegistrationContinueArrow = () => (
  <span aria-hidden="true"> →</span>
);

export const FormFieldError = ({ id, children, className }) => {
  if (children == null || children === false || children === "") {
    return null;
  }

  return (
    <div id={id} className={clsx("text-danger", "form-field-error", className)}>
      <span className="form-field-error-icon" aria-hidden>
        <svg
          width="14"
          height="14"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 1.5A6.5 6.5 0 1 0 8 14.5A6.5 6.5 0 0 0 8 1.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M8 5v3.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle cx="8" cy="11" r="0.75" fill="currentColor" />
        </svg>
      </span>
      <span className="form-field-error-text">{children}</span>
    </div>
  );
};

export default FormFieldError;
